import type { WidgetCardProps } from "legacy/constants/WidgetConstants";

type WidgetCategory =
  | "COMMON"
  | "FORMS"
  | "CONTAINERS"
  | "MEDIA"
  | "ADVANCED"
  | "CUSTOM";

export type WidgetCardsCategorized = Array<{
  widgetCategory: WidgetCategory;
  label: string;
  widgetCards: WidgetCardProps[];
}>;

/** Stub for slice initial state; widget list is supplied elsewhere for live editor flows. */
export const baseWidgets: WidgetCardsCategorized = [];
